<template>
  <div
    v-show="agencyLogoLink !== ''"
    class="agency-logo-container"
  >
    <component
      :is="template"
      :agency-name="agencyName"
      :agency-link-intern="agencyLinkIntern"
      :agency-logo-link="agencyLogoLink"
    />
  </div>
</template>

<script>
import AgencyLogoObject from 'components/AgencyLogoObject.vue';
import AgencyLogoSearch from 'components/AgencyLogoSearch.vue';

import i18nHelper from 'utils/i18nHelper';

export default {
  components: {
    AgencyLogoObject,
    AgencyLogoSearch,
  },
  i18nOptions: { namespaces: ['agency'] },
  props: {
    agencyNumber: {
      type: Number,
      required: true,
    },
    template: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      agencyName: '',
      agencyLinkIntern: '',
      agencyLogoLink: '',
      i18nHelper: i18nHelper(this.$i18n.i18next),
    };
  },
  serverPrefetch() {
    return this.getAgencyLogoData();
  },
  created() {
    // write language vars in data in case server succesfully fetched them
    if (!this.i18nHelper.get(`agency:agencyLogos.${this.agencyNumber}.agencyName`)) {
      this.getAgencyLogoData();
    } else {
      this.agencyName = this.i18nHelper.get(`agency:agencyLogos.${this.agencyNumber}.agencyName`) || '';
      this.agencyLinkIntern = this.i18nHelper.get(`agency:agencyLogos.${this.agencyNumber}.agencyUrlIntern`) || '';
      this.agencyLogoLink = this.i18nHelper.get(`agency:agencyLogos.${this.agencyNumber}.imageUrl`) || '';
    }
  },
  methods: {
    getAgencyLogoData() {
      return this.i18nHelper.checkKey(`agency:agencyLogos.${this.agencyNumber}`).then(() => {
        this.agencyName = this.$i18n.i18next.t(`agency:agencyLogos.${this.agencyNumber}.agencyName`);
        this.agencyLinkIntern = this.$i18n.i18next.t(`agency:agencyLogos.${this.agencyNumber}.agencyUrlIntern`);
        this.agencyLogoLink = this.$i18n.i18next.t(`agency:agencyLogos.${this.agencyNumber}.imageUrl`);
      }).catch(() => {
        this.agencyName = '';
        this.agencyLinkIntern = '';
        this.agencyLogoLink = '';
      });
    },
  },
};
</script>
